import React from "react";
import styles from "./MostVisitedLists.module.scss";
import { TutorialItem } from "../TutorialItem";
import { articlesData, videosData } from "../tutorials";

export function MostVisitedArticles() {
  return (
    <div className={styles.TutorialItemsWrapper}>
      {articlesData.slice(0, 3).map((article) => (
        <TutorialItem tutorial={article} key={article.name} />
      ))}
    </div>
  );
}

export function MostVisitedVideos() {
  return (
    <div className={styles.TutorialItemsWrapper}>
      {videosData.slice(0, 3).map((article) => (
        <TutorialItem tutorial={article} key={article.name} />
      ))}
    </div>
  );
}
